import React from 'react';

function InterviewAllowanceGuide({ darkMode }) {
  const containerClass = darkMode 
    ? 'min-h-screen bg-gray-900 text-white' 
    : 'min-h-screen bg-gradient-to-br from-green-50 to-emerald-100';

  const cardClass = darkMode
    ? 'bg-gray-800 border-gray-700'
    : 'bg-white border-gray-200';

  const textClass = darkMode ? 'text-gray-300' : 'text-gray-600';

  return (
    <div className={containerClass}>
      <div className="container mx-auto px-4 py-8">
        {/* 헤더 */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">💰</div>
            <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
              면접수당 받는 방법
            </h1>
            <p className={`text-lg ${textClass}`}>
              지자체 지원 프로그램과 기업 면접수당 현실적 정보 💡
            </p>
          </div>

          {/* 면접수당이란 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">🤔</span>
              면접수당이란?
            </h2>
            <div className="space-y-4">
              <div className={`${textClass}`}>
                <ul className="space-y-2">
                  <li>• 면접 참여에 대한 교통비, 시간 보상 차원의 지원금</li>
                  <li>• 기업 또는 지자체에서 지급하는 실비 성격의 지원</li>
                  <li>• <strong>법적 의무는 없음</strong> - 기업 자율 결정사항</li>
                </ul>
              </div>
            </div>
          </div>

          {/* 기업 면접수당 현실 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">🏢</span>
              기업 면접수당 현실
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className={`p-4 rounded-xl ${darkMode ? 'bg-red-900/20' : 'bg-red-50'}`}>
                <h3 className="font-semibold mb-3 text-red-600">📊 실제 지급 현황</h3>
                <div className={`space-y-2 text-sm ${textClass}`}>
                  <div>• 면접비를 받은 취준생: <strong>11.3%에 불과</strong></div>
                  <div>• 면접비 받은 경험자: 31.8%</div>
                  <div>• 대부분 기업이 지급하지 않음 (88.7%)</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
                <h3 className="font-semibold mb-3 text-blue-600">💵 실제 지급 금액</h3>
                <div className={`space-y-2 text-sm ${textClass}`}>
                  <div>• 평균: <strong>3만5천원</strong></div>
                  <div>• 일반적: 2~5만원 사이</div>
                  <div>• 원거리: 최대 10만원 (구미→서울)</div>
                  <div>• 현금 지급: 91.4%, 상품권: 16.4%</div>
                </div>
              </div>
            </div>
          </div>

          {/* 지자체 면접수당 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">🏛️</span>
              지자체 면접수당 (2025년 기준)
            </h2>
            
            <div className={`mb-4 p-4 rounded-xl ${darkMode ? 'bg-yellow-900/20' : 'bg-yellow-50'} border border-yellow-300`}>
              <p className="text-yellow-600 font-semibold">
                ⚠️ <strong>중요 안내:</strong> 지자체 청년 지원사업은 <strong>매년 사업 내용, 지원금액, 신청기간이 달라질 수 있습니다.</strong> 반드시 해당 연도 최신 공고를 확인하시기 바랍니다.
              </p>
            </div>

            <div className="space-y-4">
              <div className={`p-4 rounded-xl ${darkMode ? 'bg-green-900/20' : 'bg-green-50'}`}>
                <h3 className="font-semibold mb-2 text-green-600">🌟 경기도 청년 면접수당 (2025년)</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>대상:</strong> 경기도 거주 18~39세 청년</div>
                  <div>• <strong>지원금:</strong> 면접 1회당 5만원, 연 최대 50만원 (최대 10회)</div>
                  <div>• <strong>신청:</strong> 잡아바 어플라이(https://apply.jobaba.net/)</div>
                  <div>• <strong>지급:</strong> 경기도 지역화폐, 신청일 기준 60일 내외</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
                <h3 className="font-semibold mb-2 text-blue-600">🏙️ 서울시 (면접수당 대신 종합 지원)</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>서울시 청년수당:</strong> 월 50만원 × 최대 6개월 지원</div>
                  <div>• <strong>대상:</strong> 서울 거주 만 19~34세 미취업 청년</div>
                  <div>• <strong>신청:</strong> 청년몽땅정보통 홈페이지</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-purple-900/20' : 'bg-purple-50'}`}>
                <h3 className="font-semibold mb-2 text-purple-600">🌆 기타 지자체 (확인된 곳)</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>인천 미추홀구:</strong> 18~39세 청년 대상</div>
                  <div>• <strong>부산 해운대구:</strong> 해운대구 거주 청년 대상</div>
                  <div>• <strong>광주광역시:</strong> 청년구직활동수당 지원</div>
                </div>
              </div>
            </div>
          </div>

          {/* 신청 방법 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">📝</span>
              신청 방법 (경기도 예시)
            </h2>
            
            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">1</div>
                <div>
                  <h4 className="font-semibold">잡아바 어플라이 접속</h4>
                  <p className={`text-sm ${textClass}`}>https://apply.jobaba.net/ 방문</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">2</div>
                <div>
                  <h4 className="font-semibold">회원가입 및 로그인</h4>
                  <p className={`text-sm ${textClass}`}>실명, 휴대폰번호 정확히 입력</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">3</div>
                <div>
                  <h4 className="font-semibold">온라인 신청서 작성</h4>
                  <p className={`text-sm ${textClass}`}>면접 1회당 1건씩 작성</p>
                </div>
              </div>

              <div className="flex items-center space-x-4">
                <div className="w-8 h-8 bg-green-500 text-white rounded-full flex items-center justify-center font-bold">4</div>
                <div>
                  <h4 className="font-semibold">필수 서류 제출</h4>
                  <div className={`text-sm ${textClass} mt-1`}>
                    <div>• 온라인 신청서 및 개인정보 동의서</div>
                    <div>• 주민등록표 등·초본</div>
                    <div>• 채용 공고문</div>
                    <div>• 면접확인서 또는 면접증빙서류</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 지자체별 확인 방법 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">🔍</span>
              지자체별 확인 방법
            </h2>
            
            <div className="space-y-4">
              <div className={`p-4 rounded-xl ${darkMode ? 'bg-red-900/20' : 'bg-red-50'} border border-red-300`}>
                <h3 className="font-semibold mb-2 text-red-600">🚨 매년 변동사항 확인 필수!</h3>
                <div className={`space-y-2 text-sm ${textClass}`}>
                  <div>• <strong>각 지자체 홈페이지</strong> → "청년정책" 또는 "청년지원" 검색</div>
                  <div>• <strong>청년 전용 포털</strong> → 온통청년(www.youthcenter.go.kr)에서 통합 검색</div>
                  <div>• <strong>지자체 콜센터</strong> → 해당 지역 대표번호로 문의</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-blue-900/20' : 'bg-blue-50'}`}>
                <h3 className="font-semibold mb-2 text-blue-600">🌐 주요 지자체 청년 포털</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>서울:</strong> 청년몽땅정보통(youth.seoul.go.kr)</div>
                  <div>• <strong>경기:</strong> 경기청년포털(youth.gg.go.kr)</div>
                  <div>• <strong>부산:</strong> 부산청년(young.busan.go.kr)</div>
                  <div>• <strong>인천:</strong> 인천청년포털(youth.incheon.go.kr)</div>
                  <div>• <strong>광주:</strong> 광주청년통합플랫폼(youth.gwangju.go.kr)</div>
                </div>
              </div>
            </div>
          </div>

          {/* 문의처 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-6 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">📞</span>
              문의처
            </h2>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div className={`p-4 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                <h3 className="font-semibold mb-2">🏛️ 지자체별 문의</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>경기도:</strong> 잡아바 어플라이</div>
                  <div>• <strong>서울시:</strong> 청년수당 콜센터 1566-3344</div>
                  <div>• <strong>전국 통합:</strong> 온통청년 1670-1839</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-gray-700' : 'bg-gray-50'}`}>
                <h3 className="font-semibold mb-2">🌐 온라인 신청</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• 잡아바 어플라이: apply.jobaba.net</div>
                  <div>• 청년몽땅정보통: youth.seoul.go.kr</div>
                  <div>• 온통청년: youthcenter.go.kr</div>
                </div>
              </div>
            </div>
          </div>

          {/* 현실적 조언 */}
          <div className={`${cardClass} rounded-2xl shadow-lg p-6 mb-8 border`}>
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              <span className="text-2xl mr-3">🎯</span>
              현실적 조언
            </h2>
            
            <div className="space-y-4">
              <div className={`p-4 rounded-xl ${darkMode ? 'bg-indigo-900/20' : 'bg-indigo-50'}`}>
                <h3 className="font-semibold mb-2 text-indigo-600">📊 면접수당의 실제</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• 대부분 기업이 지급하지 않음 (88.7%가 미지급)</div>
                  <div>• 지급하는 기업도 평균 3만원 수준</div>
                  <div>• <strong>지자체 지원이 더 확실하고 체계적</strong></div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-green-900/20' : 'bg-green-50'}`}>
                <h3 className="font-semibold mb-2 text-green-600">🚀 효과적 접근</h3>
                <div className={`space-y-1 text-sm ${textClass}`}>
                  <div>• <strong>거주 지역 확인:</strong> 매년 해당 지자체 최신 청년 정책 확인</div>
                  <div>• <strong>조기 신청:</strong> 지자체 사업은 선착순이나 추첨인 경우가 많음</div>
                  <div>• <strong>종합 활용:</strong> 면접수당뿐만 아니라 구직활동수당, 청년수당 등 다양한 지원 프로그램 활용</div>
                </div>
              </div>

              <div className={`p-4 rounded-xl ${darkMode ? 'bg-yellow-900/20' : 'bg-yellow-50'} border border-yellow-300`}>
                <p className="text-yellow-600 font-semibold text-center">
                  ⚠️ "지자체 사업은 매년 예산과 정책에 따라 변경되므로, 반드시 해당 연도 최신 공고를 확인하세요!"
                </p>
              </div>
            </div>
          </div>

          {/* 버튼들 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => window.history.back()}
              className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 text-center ${
                darkMode 
                  ? 'bg-green-600 hover:bg-green-700 text-white' 
                  : 'bg-green-500 hover:bg-green-600 text-white'
              }`}
            >
              다른 가이드 보기
            </button>
            <button 
              onClick={() => window.location.href = '/'}
              className={`px-6 py-3 rounded-xl font-semibold transition-all duration-300 text-center border ${
                darkMode 
                  ? 'border-gray-600 text-gray-300 hover:bg-gray-800' 
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
            >
              홈으로 돌아가기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterviewAllowanceGuide;